export default "__VITE_ASSET__BySDpBh4__"